// contexts/produtos/VariacaoContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const VariacaoContext = createContext();

export const useVariacao = () => useContext(VariacaoContext);

export const VariacaoProvider = ({ children }) => {
    const [variacoes, setVariacoes] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                const result = await fetchData('/Variacao');
                setVariacoes(result);
            } catch (error) {
                console.error('Erro ao buscar variacoes:', error);
            }
        };

        fetchDataFromAPI();
    }, []);

    const addVariacao = async (variacao) => {
        try {
            const result = await postData('/Variacao', variacao);
            setVariacoes((current) => [...current, result]);
            showAlert('Variacao adicionada com sucesso!');
            return result;
        } catch (error) {
            console.error('Erro ao adicionar variacao:', error);
            showMessage(`Erro ao adicionar variacao!\n${error}`, 'danger');
            return null;
        }
    };

    const updateVariacao = async (variacao) => {
        try {
            const result = await putData('/Variacao', variacao);
            setVariacoes((current) => current.map((v) => (v.id === result.id ? result : v)));
            showAlert('Variacao alterada com sucesso!');
            return result;
        } catch (error) {
            console.error('Erro ao atualizar variacao:', error);
            showMessage(`Erro ao atualizar variacao!\n${error}`, 'danger');
            return null;
        }
    };

    const deleteVariacao = async (id) => {
        try {
            await deleteData('/Variacao', { variacaoId: id });
            setVariacoes((current) => current.filter((v) => v.id !== id));
            showAlert('Variacao excluida com sucesso!');
            return true;
        } catch (error) {
            console.error('Erro ao excluir variacao:', error);
            showMessage(`Erro ao excluir variacao!\n${error}`, 'danger');
            return false;
        }
    };

    return (
        <VariacaoContext.Provider value={{ variacoes, addVariacao, updateVariacao, deleteVariacao }}>
            {children}
        </VariacaoContext.Provider>
    );
};
